<ng-container *ngIf="isInquiryNotFound; else claimContent">
  <div class="claim-not-found" role="alert">
    <div class="claim-not-found-card">
      <mat-icon aria-hidden="true">search_off</mat-icon>
      <h3>{{ "inquiryNotFound" | translate }}</h3>
      <p>{{ "inquiryNotFoundDetail" | translate }}</p>

      <button type="button" (click)="onClickClaimCenter()">
        {{ "backToInquiryCenter" | translate }}
      </button>
    </div>
  </div>
</ng-container>

<ng-template #claimContent>
  <div class="claim-page" [class.inquiry-view-mode]="!isEditMode" [class.inquiry-edit-mode]="isEditMode">
    <header class="claim-page-header">
      <nav class="claim-breadcrumb" aria-label="Breadcrumb">
        <button
          type="button"
          class="breadcrumb-home"
          (click)="onClickClaimCenter()"
        >
          {{ "inquiryCenter" | translate }}
        </button>
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
        <span class="breadcrumb-current">{{ selectedClaim?.csNumber }}</span>
      </nav>

      <div class="claim-pagination" aria-label="Claim navigation">
        <button
          type="button"
          class="pagination-button"
          [disabled]="!canGoPrevious"
          (click)="goToPreviousClaim()"
        >
          {{ "previous" | translate }}
        </button>
        <button
          type="button"
          class="pagination-button"
          [disabled]="!canGoNext"
          (click)="goToNextClaim()"
        >
          {{ "next" | translate }}
        </button>
      </div>
    </header>
    <div *ngIf="!selectedClaim?.csNumber&&!isEditMode" style="margin-top: 12px;">{{ "inquiryNoCSNo" | translate }}</div>

    <div class="status-row">
      <p-dropdown
        [ngClass]="{
          'status-dropdown': true,
          'open': currStatus?.name === 'open',
          'new': currStatus?.name === 'new',
          'resolved': currStatus?.name === 'resolved'
        }"
        [options]="statusOptions"
        displayProperty="name"
        [(ngModel)]="currStatus"
        [ngModelOptions]="{ standalone: true }"
        optionLabel="name"
        (onChange)="onStatusSelect()"
        [style]="{ width: '158px' }"
        [disabled]="!isEditMode"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <span>{{ currStatus?.name | translate }}</span>
        </ng-template>
        <ng-template pTemplate="item" let-item>
          <span [ngClass]="getStatusClass(item.name)">{{ item.name | translate }}</span>
        </ng-template>
      </p-dropdown>
    </div>

    <h1 class="claim-title" *ngIf="!isEditMode">
      <span class="id">{{ selectedClaim?.csNumber }}</span>
      <span >{{ selectedClaim?.title }}</span>
    </h1>

    <div *ngIf="isEditMode" class="title-textarea">
      <div class="form-field full-width-field">
        <span id="editCsNumberLabel">{{ "csNo" | translate }}</span>

        <div
          class="cs-no-input"
          role="group"
          aria-labelledby="editCsNumberLabel"
        >
          <span>CS</span>

          <input
            pInputText
            type="text"
            [(ngModel)]="csNumberDate"
            [ngModelOptions]="{ standalone: true }"
            placeholder="YYMMDD"
            maxlength="6"
            inputmode="numeric"
            aria-label="CS number date"
          />

          <span>-</span>

          <input
            pInputText
            type="text"
            [(ngModel)]="csNumberSequence"
            [ngModelOptions]="{ standalone: true }"
            placeholder="1"
            inputmode="numeric"
            aria-label="CS number sequence"
          />
        </div>
      </div>
    </div>

    <div *ngIf="isEditMode" class="title-textarea">
      <label class="form-field input-field-wrap full-width-field">
        <span>{{ "title" | translate }}</span>
        <input
          pInputText
          type="text"
          required
          #titleInput="ngModel"
          [(ngModel)]="updatedClaim.title"
        />
        <small class="p-error" *ngIf="titleInput.invalid && titleInput.dirty">
          {{ "titleRequired" | translate }}
        </small>
      </label>
    </div>

    <div class="claim-layout">
      <div class="inquiry-edit-actions" *ngIf="isEditMode">
        <div class="claim-actions" *ngIf="!auth.isYakuin">
          <button
            type="button"
            class="secondary-button"
            (click)="onClickCancelEdit()"
          >
            {{ "cancel" | translate }}
          </button>

          <button
            type="button"
            class="primary-button"
            [disabled]="!updatedClaim.title?.trim()"
            (click)="updateClaim()"
          >
            {{ "saveChanges" | translate }}
          </button>
        </div>
      </div>
      <div class="inquiry-view-actions" *ngIf="!isEditMode">
        <div class="claim-actions" *ngIf="!auth.isYakuin">
          <button
            type="button"
            class="text-action danger-action"
            (click)="onDelete()"
          >
            <mat-icon aria-hidden="true">delete_outline</mat-icon>
            {{ "deleteInquiry" | translate }}
          </button>
          <button
            type="button"
            class="text-action"
            (click)="onClickEdit()"
          >
            <mat-icon aria-hidden="true">edit</mat-icon>
            {{ "editInquiry" | translate }}
          </button>
        </div>
      </div>
      <main class="tab-area">
        <mat-tab-group class="claim-tabs">
          <mat-tab [label]="'inquiryForm' | translate">
            <div class="claim-tab-content">
              <div class="inquiry-form-meta">
                <div class="claim-created">
                  <span>
                    {{ "createdAt" | translate }}
                    {{ formatDate(selectedClaim?.createdAt) }} JST
                  </span>

                  <span>
                    {{ "updatedAt" | translate }}
                    {{ formatDate(selectedClaim?.updatedAt) }} JST
                  </span>
                </div>
                <div class="inquiry-conversion" *ngIf="!isEditMode || relatedClaim" aria-live="polite">
                  <ng-container *ngIf="relatedClaim as claim; else conversionAction">
                    <span>{{ "createdIntoClaim" | translate }}:</span>
                    <a
                      class="inline-link"
                      [routerLink]="[
                        '/dashboard/claim-center/claim-edit',
                        claim.readableId
                      ]"
                    >
                      {{ claim.csNumber || claim.readableId }}
                    </a>
                  </ng-container>
                  <ng-template #conversionAction>
                    <button *ngIf="!auth.isYakuin" type="button" class="primary-button"
                      [disabled]="relatedClaimState !== 'ready'"
                      (click)="onClickConvert()">
                      {{ "createClaimFromInquiry" | translate }}
                    </button>
                  </ng-template>
                </div>
              </div>

              <div class="section-title-row">
                <h3>{{ "inquiryDetails" | translate }}</h3>
                <button
                  *ngIf="isEditMode"
                  type="button"
                  class="inline-link"
                  (click)="openOriginalForm()"
                >
                  {{ "viewOriginalForm" | translate }}
                </button>
              </div>

              <ng-container *ngIf="!isEditMode">
                <div class="overview-grid">
                  <section class="overview-card">
                    <button
                      type="button"
                      class="record-link"
                      (click)="goVesselDetails(updatedClaimVessel)"
                    >
                      {{ updatedClaimVessel?.name || updatedClaimVessel?.otherName }}
                    </button>
                    <div class="overview-line">
                      <span>{{ "shipyard" | translate }}</span>
                      <button
                        type="button"
                        class="inline-link"
                        (click)="goCompanyDetails(vesselBuilder)"
                      >
                        {{ getCurrShipyard(updatedClaimVessel?.builder_id) }}
                      </button>
                    </div>
                    <div class="overview-line stacked-line">
                      <span>{{ "vesselNumber" | translate }}</span>
                      <strong>{{ updatedClaimVessel?.vesselNumber }}</strong>
                    </div>
                  </section>

                  <section class="overview-card">
                    <div class="record-link">
                      {{ updatedClaimVesselEquip?.name }}
                    </div>
                    <div class="overview-line">
                      <span>{{ "serialNo" | translate }}</span>
                      <strong>{{ updatedClaimVesselEquip?.serialNumber }}</strong>
                    </div>
                    <div class="overview-line stacked-line">
                      <span>{{ "prodNameAndType" | translate }}</span>
                      <strong>
                        {{ claimProd?.name || "-" }} / 
                        {{ claimProdCategory?.name || "-"  }}
                      </strong>
                    </div>
                  </section>
                </div>

                <section class="incident-card">
                  <h3>{{ "incidentDetails" | translate }}</h3>
                  <div class="incident-meta">
                    <div>
                      <mat-icon aria-hidden="true">calendar_today</mat-icon>
                      <span
                        >{{ selectedClaim?.incidentDate | date: 'yyyy/MM/dd':'+0900' }}</span
                      >
                    </div>
                    <div>
                      <mat-icon aria-hidden="true">schedule</mat-icon>
                      <span
                        >{{ selectedClaim?.incidentDate | date: 'HH:mm':'+0900' }}
                        JST</span
                      >
                    </div>
                    <div>
                      <mat-icon aria-hidden="true">location_on</mat-icon>
                      <span>{{ selectedClaim?.incidentPlace }}</span>
                    </div>
                  </div>

                  <div class="incident-answers">
                    <div class="answer-block">
                      <h4>{{ "incidentLeadup" | translate }}</h4>
                      <p>{{ selectedClaim?.incidentLeadup }}</p>
                    </div>
                    <div class="answer-block">
                      <h4>{{ "currStatus" | translate }}</h4>
                      <p>{{ selectedClaim?.equipmentCurrentStatus }}</p>
                    </div>
                    <div class="answer-block">
                      <h4>{{ "measuresTaken" | translate }}</h4>
                      <p>{{ selectedClaim?.responseMeasures }}</p>
                    </div>
                    <div class="answer-block">
                      <h4>{{ "detailsJRCS" | translate }}</h4>
                      <p>{{ selectedClaim?.responseRequestDetails }}</p>
                    </div>
                    <div class="answer-block">
                      <h4>{{ "otherDetailsJRCS" | translate }}</h4>
                      <p>{{ selectedClaim?.extraDetails }}</p>
                    </div>
                  </div>

                  <div class="attachment-gallery" *ngIf="files?.length">
                    <div
                      *ngFor="let file of files"
                      class="attachment-card"
                      role="button"
                      tabindex="0"
                      (click)="downloadFile(file.id, file.filename, file.filetype)"
                      (keyup.enter)="downloadFile(file.id, file.filename, file.filetype)"
                    >
                      <div class="attachment-preview">
                        <img
                          *ngIf="file.filetype?.startsWith('image/') && file.previewUrl"
                          [src]="file.previewUrl"
                          [alt]="file.filename"
                        />
                        <mat-icon
                          *ngIf="!file.filetype?.startsWith('image/') || !file.previewUrl"
                          aria-hidden="true"
                        >
                          {{ file.filetype === 'application/pdf' ?
                          'picture_as_pdf' : 'insert_drive_file' }}
                        </mat-icon>
                      </div>
                      <div class="attachment-name" [title]="file.filename">
                        {{ file.filename }}
                      </div>
                      <div class="attachment-meta">
                        {{ formatFileSize(file.filesize) }}
                      </div>
                    </div>
                  </div>
                </section>

                <section class="other-details-section">
                  <h3>{{ "otherDetails" | translate }}</h3>
                  <div class="other-details-grid">
                    <div class="readout-card half-width">
                      <span>{{ "vesselType" | translate }}</span>
                      <strong>{{ updatedClaimVessel?.shipType }}</strong>
                    </div>
                    <div class="readout-card half-width">
                      <span>{{ "imo" | translate }}</span>
                      <strong>{{ updatedClaimVessel?.imo }}</strong>
                    </div>
                    <div class="readout-card half-width">
                      <span>{{ "owner" | translate }}</span>
                      <strong>{{ vesselOwner?.name }}</strong>
                    </div>
                    <div class="readout-card half-width">
                      <span>{{ "companyName" | translate }}</span>
                      <strong>{{ claimCompany?.name }}</strong>
                    </div>
                    <div class="readout-card third-width">
                      <span>{{ "shipDeliveryDate" | translate }}</span>
                      <strong>{{ updatedClaimVesselEquip?.shipDeliveryDate }}</strong>
                    </div>
                    <div class="readout-card third-width">
                      <span>{{ "retrofittingDate" | translate }}</span>
                      <strong>{{ updatedClaimVesselEquip?.retrofittingDate }}</strong>
                    </div>
                    <div class="readout-card third-width">
                      <span>{{ "warranty" | translate }}</span>
                      <strong
                        >{{ formatDate(updatedClaimVesselEquip?.warrantyExpirationDate)
                        }}</strong
                      >
                    </div>
                  </div>
                </section>

                <section class="incident-card">
                  <h3>{{ "contactInfo" | translate }}</h3>
                  <div class="incident-answers">
                    <div class="answer-block">
                      <h4>{{ "companyContactName" | translate }}</h4>
                      <p>{{ selectedClaim?.contactPersonName }}</p>
                    </div>
                    <div class="answer-block">
                      <h4>{{ "contactEmail" | translate }}</h4>
                      <p>{{ selectedClaim?.contactPersonEmail }}</p>
                    </div>
                    <div class="answer-block">
                      <h4>{{ "contactPhone" | translate }}</h4>
                      <p>{{ selectedClaim?.contactPersonPhone }}</p>
                    </div>
                    <div class="answer-block">
                      <h4>{{ "contactAddress" | translate }}</h4>
                      <p>{{ selectedClaim?.contactPersonAddress }}</p>
                    </div>
                  </div>
                </section>
              </ng-container>

              <ng-container *ngIf="isEditMode">
                <div class="edit-overview-grid">
                  <label class="form-field dropdown-field">
                    <span>{{ "vesselName" | translate }}</span>
                    <p-dropdown
                      [ngClass]="'design-dropdown'"
                      [options]="vesselList"
                      [filter]="true"
                      filterBy="name,otherName"
                      displayProperty="name"
                      [(ngModel)]="updatedClaimVessel"
                      [placeholder]="'selectVessel' | translate"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="onVesselSelected()"
                      optionLabel="name"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="38"
                      [showClear]="true"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                    >
                      <ng-template pTemplate="selectedItem" let-selectedOption>
                        <span>{{ selectedOption?.name || selectedOption?.otherName }}</span>
                      </ng-template>
                      <ng-template pTemplate="item" let-vessel>
                        <span>{{ vessel?.name || vessel?.otherName }}</span>
                      </ng-template>
                    </p-dropdown>
                  </label>

                  <label class="form-field dropdown-field">
                    <span>{{ "equipProdName" | translate }}</span>
                    <p-dropdown
                      [ngClass]="'design-dropdown'"
                      [options]="vesselEquipList"
                      [filter]="true"
                      filterBy="name"
                      displayProperty="name"
                      [(ngModel)]="updatedClaimVesselEquip"
                      (onChange)="onVesselEquipSelected()"
                      [placeholder]="
                        (!updatedClaimVessel ? 'selectVesselFirst' : 'selectEquip') | translate
                      "
                      [ngModelOptions]="{ standalone: true }"
                      optionLabel="name"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="38"
                      [showClear]="true"
                      [disabled]="!updatedClaimVessel"
                      [style]="{ width: '100%' }"
                      appendTo="body"
                    ></p-dropdown>
                  </label>

                  <div class="form-field readonly-field">
                    <span>{{ "shipyard" | translate }}</span>
                    <strong>{{ getCurrShipyard(updatedClaimVessel?.builder_id) }}</strong>
                  </div>
                  <div class="form-field readonly-field">
                    <span>{{ "serialNo" | translate }}</span>
                    <strong
                      >{{ updatedClaimVesselEquip?.serialNumber ||
                      updatedClaimVesselEquip?.serialNumber }}</strong
                    >
                  </div>
                  <div class="form-field readonly-field">
                    <span>{{ "vesselNumber" | translate }}</span>
                    <strong>{{ updatedClaimVessel?.vesselNumber }}</strong>
                  </div>
                  <div class="form-field readonly-field">
                    <span>{{ "prodNameAndType" | translate }}</span>
                    <strong>
                      {{ updatedClaimProd?.name || "-" }} / 
                      {{ updatedClaimProdCategory?.name || "-"  }}
                    </strong>
                  </div>
                </div>

                <section class="edit-incident-section">
                  <h3>{{ "incidentDetails" | translate }}</h3>

                  <label class="form-field input-field-wrap full-width-field">
                    <span>{{ "incidentTime" | translate }} (JST)</span>
                    <input
                      class="jst-datetime-input"
                      type="datetime-local"
                      matInput
                      [(ngModel)]="incidentDateLocalString"
                    />
                  </label>

                  <label class="form-field input-field-wrap full-width-field">
                    <span>{{ "incidentPlace" | translate }}</span>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="updatedClaim.incidentPlace"
                    />
                    <mat-icon aria-hidden="true">location_on</mat-icon>
                  </label>

                  <label class="form-field textarea-field full-width-field">
                    <span>{{ "incidentLeadup" | translate }}</span>
                    <textarea
                      pInput
                      rows="5"
                      [(ngModel)]="updatedClaim.incidentLeadup"
                    ></textarea>
                  </label>

                  <label class="form-field textarea-field full-width-field">
                    <span>{{ "currStatus" | translate }}</span>
                    <textarea
                      pInput
                      rows="5"
                      [(ngModel)]="updatedClaim.equipmentCurrentStatus"
                    ></textarea>
                  </label>

                  <label class="form-field textarea-field full-width-field">
                    <span>{{ "measuresTaken" | translate }}</span>
                    <textarea
                      pInput
                      rows="5"
                      [(ngModel)]="updatedClaim.responseMeasures"
                    ></textarea>
                  </label>

                  <label class="form-field textarea-field full-width-field">
                    <span>{{ "detailsJRCS" | translate }}</span>
                    <textarea
                      pInput
                      rows="5"
                      [(ngModel)]="updatedClaim.responseRequestDetails"
                    ></textarea>
                  </label>

                  <label class="form-field textarea-field full-width-field">
                    <span>{{ "otherDetailsJRCS" | translate }}</span>
                    <textarea
                      pInput
                      rows="5"
                      [(ngModel)]="updatedClaim.extraDetails"
                    ></textarea>
                  </label>
                </section>

                <section class="edit-incident-section">
                  <h3>{{ "contactInfo" | translate }}</h3>

                  <label class="form-field input-field-wrap full-width-field">
                    <span>{{ "companyContactName" | translate }}</span>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="updatedClaim.contactPersonName"
                    />
                  </label>

                  <label class="form-field input-field-wrap full-width-field">
                    <span>{{ "contactEmail" | translate }}</span>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="updatedClaim.contactPersonEmail"
                    />
                  </label>

                  <label class="form-field input-field-wrap full-width-field">
                    <span>{{ "contactPhone" | translate }}</span>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="updatedClaim.contactPersonPhone"
                    />
                  </label>

                  <label class="form-field input-field-wrap full-width-field">
                    <span>{{ "contactAddress" | translate }}</span>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="updatedClaim.contactPersonAddress"
                    />
                  </label>
                </section>

                <mat-expansion-panel class="attachments-panel" expanded="true">
                  <mat-expansion-panel-header [collapsedHeight]="'42px'">
                    <mat-panel-title
                      >{{ "attachments" | translate }}</mat-panel-title
                    >
                  </mat-expansion-panel-header>
                  <app-file-upload
                    [selectedVessel]="updatedClaimVessel"
                    [existingFiles]="files"
                    (fileListChange)="onFileListChange($event)"
                  ></app-file-upload>
                </mat-expansion-panel>
              </ng-container>
            </div>
          </mat-tab>

          <mat-tab [label]="'emailThread' | translate">
            <div class="secondary-tab-content">
              <div class="new-thread-action" *ngIf="showNewEmailBtn">
                <button
                  class="new-email-btn"
                  (click)="createEmailThread()"
                >
                  {{ "newEmailThread" | translate }}
                </button>
              </div>

              <div class="reply-area" *ngIf="createNewEmailThread">
                <mat-form-field class="recipient-field" appearance="outline">
                  <div class="recipient-row">
                    <div class="recipient-prefix">To:</div>
                    <mat-chip-grid #newThreadChipGrid>
                      <mat-chip-row
                        *ngFor="let user of selectedRecipients['new']"
                        [removable]="true"
                        (removed)="removeRecipient(user, 'new')"
                      >
                        {{ user.name || user.email }}
                        <button matChipRemove><mat-icon>close</mat-icon></button>
                      </mat-chip-row>
                      <input
                        #newThreadRecipientInput
                        placeholder="{{ 'addRecipient' | translate }}"
                        [formControl]="recipientCtrl['new']"
                        [matAutocomplete]="newThreadAuto"
                        [matChipInputFor]="newThreadChipGrid"
                      />
                    </mat-chip-grid>
                  </div>
                  <mat-autocomplete
                    #newThreadAuto="matAutocomplete"
                    (optionSelected)="selectUser($event, 'new', newThreadRecipientInput)"
                  >
                    <mat-option
                      *ngFor="let user of filteredRecipients['new'] | async"
                      [value]="user"
                    >
                      {{ user.name }} ({{ user.email }})
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <textarea
                  class="email-body"
                  placeholder="{{ 'writeResponse' | translate }}"
                  [(ngModel)]="message"
                ></textarea>

                <div class="upload-list">
                  <div *ngFor="let file of newEmailFiles" class="file-item">
                    <div class="upload-file-main">
                      <ng-container [ngSwitch]="file.status">
                        <mat-spinner
                          *ngSwitchCase="'uploading'"
                          diameter="24"
                          strokeWidth="3"
                        ></mat-spinner>
                        <mat-icon *ngSwitchCase="'done'">check</mat-icon>
                        <mat-icon *ngSwitchCase="'error'">error</mat-icon>
                      </ng-container>
                      <div class="file-details">
                        <div>{{ file.name }}</div>
                        <div
                          class="file-size-container"
                          *ngIf="file.status === 'done'"
                        >
                          <span
                            class="uploaded-text"
                            [@fadeInOut]="file.showUploaded ? 'visible' : 'hidden'"
                            >Uploaded</span
                          >
                          <span
                            class="file-size"
                            [@fadeInOut]="file.showUploaded ? 'hidden' : 'visible'"
                            >{{ formatFileSize(file.size) }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <mat-icon
                      (click)="removeFile(file, newEmailFiles)"
                      class="remove-icon"
                      >close</mat-icon
                    >
                  </div>
                </div>

                <div class="composer-actions">
                  <button
                    type="button"
                    (click)="triggerFileInput('emailFileInput')"
                    aria-label="Attach files"
                  >
                    <mat-icon svgIcon="attachment"></mat-icon>
                    <input
                      #emailFileInput
                      id="emailFileInput"
                      type="file"
                      multiple
                      (change)="onFileSelected($event, newEmailFiles, emailFileInputRef)"
                      hidden
                    />
                  </button>
                  <button
                    type="button"
                    (click)="sendReply('new', null)"
                    aria-label="Send email"
                  >
                    <mat-icon svgIcon="send"></mat-icon>
                  </button>
                </div>
              </div>

              <div *ngFor="let thread of emailThreads" class="email-thread">
                <div *ngFor="let email of thread">
                  <article class="message-card">
                    <header class="message-header">
                      <img src="../assets/images/profile-image.png" alt="" />
                      <div class="sender">
                        <div class="name">{{ getUserName(email.sender_id) }}</div>
                        <div class="company">
                          {{ getUserCompanyName(email.sender_id) }}
                        </div>
                      </div>
                    </header>
                    <div class="message-content">
                      <p>{{ email.displayBody }}</p>
                      <div class="message-meta">
                        sent by email&emsp;{{ formatDateLocal(email.updated_at) }}
                      </div>
                      <div
                        *ngIf="emailFiles[email.id]"
                        class="message-attachments"
                      >
                        <button
                          type="button"
                          class="message-file"
                          *ngFor="let file of emailFiles[email.id]"
                          (click)="downloadFile(file.id, file.filename, file.filetype)"
                        >
                          <img
                            *ngIf="file.filetype.startsWith('image/')"
                            [src]="file.previewUrl"
                            [alt]="file.filename"
                          />
                          <iframe
                            *ngIf="file.filetype === 'application/pdf' && file.previewUrl"
                            [src]="file.previewUrl"
                            width="100%"
                            height="72px"
                            title="PDF preview"
                          ></iframe>
                          <mat-icon
                            *ngIf="!file.filetype.startsWith('image/') && file.filetype !== 'application/pdf'"
                            >insert_drive_file</mat-icon
                          >
                          <span>{{ file.filename }}</span>
                        </button>
                      </div>
                    </div>
                  </article>
                </div>

                <div class="reply-area">
                  <mat-form-field class="recipient-field" appearance="outline">
                    <div class="recipient-row">
                      <div class="recipient-prefix">To:</div>
                      <mat-chip-grid #threadChipGrid>
                        <mat-chip-row
                          *ngFor="let user of selectedRecipients[thread[0].thread_id]"
                          [removable]="true"
                          (removed)="removeRecipient(user, thread[0].thread_id)"
                        >
                          {{ user.name || user.email }}
                          <button matChipRemove>
                            <mat-icon>close</mat-icon>
                          </button>
                        </mat-chip-row>
                        <input
                          #threadRecipientInput
                          placeholder="{{ 'addRecipient' | translate }}"
                          [formControl]="recipientCtrl[thread[0].thread_id]"
                          [matAutocomplete]="threadAuto"
                          [matChipInputFor]="threadChipGrid"
                        />
                      </mat-chip-grid>
                    </div>
                    <mat-autocomplete
                      #threadAuto="matAutocomplete"
                      (optionSelected)="selectUser($event, thread[0].thread_id, threadRecipientInput)"
                    >
                      <mat-option
                        *ngFor="let user of filteredRecipients[thread[0].thread_id] | async"
                        [value]="user"
                      >
                        {{ user.name }} ({{ user.email }})
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                  <textarea
                    class="email-body"
                    placeholder="{{ 'writeResponse' | translate }}"
                    [(ngModel)]="message"
                  ></textarea>

                  <div class="composer-actions">
                    <button
                      type="button"
                      (click)="threadEmailFileInput.click()"
                      aria-label="Attach files"
                    >
                      <mat-icon svgIcon="attachment"></mat-icon>
                      <input
                        #threadEmailFileInput
                        type="file"
                        multiple
                        (change)="
                          onFileSelected(
                            $event,
                            newEmailFiles,
                            emailFileInputRef
                          )
                        "
                        hidden
                      />
                    </button>
                    <button
                      type="button"
                      (click)="sendReply(thread[0].thread_id, thread.at(-1).id)"
                      aria-label="Send email"
                    >
                      <mat-icon svgIcon="send"></mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

        </mat-tab-group>
      </main>

      <aside class="right-column" [attr.edit-mode]="isEditMode">
        <section class="sidebar-card requester-card">
          <h3>{{ "requester" | translate }}</h3>

          <button
            *ngIf="claimSubmitter"
            type="button"
            class="sidebar-link requester-name"
            (click)="goRequesterDetails(claimSubmitter)"
          >
            {{ claimSubmitter?.name }}
          </button>
          <span *ngIf="!claimSubmitter">{{ "unknown" | translate }}</span>

          <div class="requester-line">
            <span>{{ "companyName" | translate }}:</span>
            <button
              *ngIf="submitterCompany"
              type="button"
              class="sidebar-link"
              (click)="goCompanyDetails(submitterCompany)"
            >
              {{ submitterCompany?.name }}
            </button>
            <span *ngIf="!submitterCompany">{{ "unknown" | translate }}</span>
          </div>

          <div class="requester-line">
            <span>{{ "position" | translate }}:</span>
            <span>{{ claimSubmitter?.position || ("unknown" | translate) }}</span>
          </div>

          <div class="requester-contact">
            <a [href]="'mailto:' + claimSubmitter?.email">
              {{ claimSubmitter?.email }}
            </a>
            <a [href]="'tel:' + claimSubmitter?.telephone">
              {{ claimSubmitter?.telephone }}
            </a>
            <span>{{ claimSubmitter?.address }}</span>
          </div>
        </section>

        <ng-container *ngIf="!isEditMode">
          <section class="sidebar-card assigned-card">
            <h3>{{ "assignedAgent" | translate }}</h3>

            <div class="sidebar-view-value">
              {{ getAssigneeLabel(currAssignee) || ("notAssigned" | translate) }}
            </div>
          </section>

          <section class="sidebar-card next-port-card">
            <h3>{{ "expectedPortCall" | translate }}</h3>

            <div class="port-details-list">
              <div class="port-detail">
                <mat-icon aria-hidden="true">calendar_today</mat-icon>
                <span>
                  {{
                    selectedClaim?.expectedPortCall
                      | date: "yyyy/MM/dd" : "+0900"
                  }}
                </span>
              </div>

              <div class="port-detail">
                <mat-icon aria-hidden="true">schedule</mat-icon>
                <span>
                  {{
                    selectedClaim?.expectedPortCall
                      | date: "HH:mm" : "+0900"
                  }}
                  JST
                </span>
              </div>

              <div class="port-detail">
                <mat-icon aria-hidden="true">location_on</mat-icon>
                <span>{{ selectedClaim?.nextPort }}</span>
              </div>
            </div>
          </section>

          <section class="sidebar-card settings-card">
            <div class="sidebar-field-group">
              <h3>{{ "priority" | translate }}</h3>
              <div class="sidebar-view-value">
                {{ currPriority?.name | translate }}
              </div>
            </div>

            <div class="sidebar-field-group">
              <h3>{{ "mark" | translate }}</h3>
              <div class="sidebar-view-value">
                {{ currMark?.name | translate }}
              </div>
            </div>

            <div class="confidential-view-row">
              <h3>{{ "confidential" | translate }}</h3>
              <span class="confidential-value">
                {{ isConfidential === 1 ? "Yes" : "No" }}
              </span>
            </div>

            <div class="tags-section">
              <div class="tags-heading">
                <h3>{{ "tags" | translate }} ({{ tags.length }})</h3>

                <button
                  type="button"
                  class="tags-toggle-button"
                  (click)="toggleTags()"
                  [attr.aria-expanded]="isTagsExpanded"
                >
                  <mat-icon
                    aria-hidden="true"
                    [class.expanded]="isTagsExpanded"
                  >
                    expand_more
                  </mat-icon>
                </button>
              </div>

              <ng-container *ngIf="isTagsExpanded">
                <div class="tag-list">
                  <span *ngFor="let tag of tags" class="tag-chip">
                    {{ tag }}
                  </span>

                  <span *ngIf="tags.length === 0" class="no-tags">
                    {{ "noTags" | translate }}
                  </span>
                </div>
              </ng-container>
            </div>
          </section>
        </ng-container>

        <ng-container *ngIf="isEditMode">
          <section class="sidebar-card assigned-card">
            <h3>{{ "assignedAgent" | translate }}</h3>

            <p-dropdown
              [ngClass]="'sidebar-dropdown'"
              [options]="agentList"
              [filter]="true"
              filterBy="name,email"
              displayProperty="name"
              dataKey="id"
              [showClear]="true"
              [(ngModel)]="assignee"
              [placeholder]="'selectAssignee' | translate"
              [ngModelOptions]="{ standalone: true }"
              optionLabel="displayLabel"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38"
              (onChange)="onAssigneeSelect()"
              [style]="{ width: '100%' }"
              appendTo="body"
            ></p-dropdown>
          </section>

          <section class="sidebar-card next-port-card">
            <h3>{{ "expectedPortCall" | translate }}</h3>

            <div class="sidebar-edit-stack" style="margin-top: 12px;">
              <label class="form-field input-field-wrap sidebar-edit-field">
                <span>{{ "nextPortDate" | translate }} (JST)</span>
                <input
                  class="jst-datetime-input"
                  type="datetime-local"
                  matInput
                  [(ngModel)]="expectedPortCallLocalString"
                />
              </label>

              <label class="form-field input-field-wrap sidebar-edit-field" style="margin-top: 12px;">
                <span >{{ "nextPortPlace" | translate }}</span>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="updatedClaim.nextPort"
                />
                <mat-icon aria-hidden="true">location_on</mat-icon>
              </label>
            </div>
          </section>

          <section class="sidebar-card settings-card">
            <div class="sidebar-field-group">
              <h3>{{ "priority" | translate }}</h3>

              <p-dropdown
                [ngClass]="'sidebar-dropdown'"
                [options]="priority"
                displayProperty="name"
                [(ngModel)]="selectedPriority"
                [ngModelOptions]="{ standalone: true }"
                optionLabel="name"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                [style]="{ width: '100%' }"
                appendTo="body"
              >
                <ng-template pTemplate="selectedItem" let-option>
                  {{ option.name | translate }}
                </ng-template>

                <ng-template pTemplate="item" let-option>
                  {{ option.name| translate }}
                </ng-template>
              </p-dropdown>
            </div>

            <div class="sidebar-field-group">
              <h3>{{ "mark" | translate }}</h3>

              <p-dropdown
                [ngClass]="'sidebar-dropdown'"
                [options]="mark"
                displayProperty="name"
                [(ngModel)]="selectedMark"
                [ngModelOptions]="{ standalone: true }"
                optionLabel="name"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                [style]="{ width: '100%' }"
                appendTo="body"
              >
                <ng-template pTemplate="selectedItem" let-option>
                  {{ option.name | translate }}
                </ng-template>

                <ng-template pTemplate="item" let-option>
                  {{ option.name| translate }}
                </ng-template>
              </p-dropdown>
            </div>

            <label class="confidential-row">
              <h3>{{ "confidential" | translate }}</h3>

              <span class="confidential-value">
                {{ isConfidential === 1 ? "Yes" : "No" }}
              </span>

              <span class="switch-control">
                <input
                  type="checkbox"
                  [checked]="isConfidential === 1"
                  (change)="onConfidentialChange($event)"
                />
                <span class="switch-track" aria-hidden="true"></span>
              </span>
            </label>

            <div class="tags-section">
              <div class="tags-heading" (click)="toggleTags()">
                <h3>{{ "tags" | translate }} ({{ tags.length }})</h3>

                <button
                  type="button"
                  class="tags-toggle-button"
                  [attr.aria-expanded]="isTagsExpanded"
                >
                  <mat-icon
                    aria-hidden="true"
                    [class.expanded]="isTagsExpanded"
                  >
                    expand_more
                  </mat-icon>
                </button>
              </div>

              <ng-container *ngIf="isTagsExpanded">
                <div
                  class="tags-input-wrapper"
                  (input)="onTagInput($event)"
                  (mouseup)="onChipMouseUp($event)"
                >
                  <p-chips
                    #chipRef
                    [(ngModel)]="tags"
                    [ngModelOptions]="{ standalone: true }"
                    styleClass="claim-tags-input"
                    inputId="claim-tags-input"
                    [placeholder]="'enterTag' | translate"
                    [ariaLabel]="'tags' | translate"
                    [allowDuplicate]="false"
                    [caseSensitiveDuplication]="false"
                    [addOnBlur]="true"
                    separator=","
                    (onFocus)="openTagSuggestions($event)"
                    (onAdd)="onTagAdded()"
                    (onBlur)="closeTagSuggestions()"
                  ></p-chips>

                  <div
                    *ngIf="showTagSuggestions && filteredTagOptions.length"
                    class="tag-suggestions"
                  >
                    <button
                      *ngFor="let option of filteredTagOptions"
                      type="button"
                      class="tag-suggestion"
                      (mousedown)="selectTagSuggestion(option, $event)"
                    >
                      {{ option }}
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </section>
        </ng-container>
      </aside>
    </div>
  </div>
</ng-template>